/* @flow */

import $ from 'jquery';
import React, { Component } from 'react';
import fetch, { handleFetchError } from 'utils/fetch';
import { redirectToResponse } from 'utils/redirect';
import { Modal, Button, Message } from 'semantic-ui-react';
import AcceptAccountRequestModal from './components/AcceptAccountRequestModal';
import { mountComponent, unmountCurrentComponent } from 'utils/modals';
import { displayError } from 'utils/errors';
import { storeSuccess } from 'plugins/toastr';

export const index = () => {
  $('table tr .decline.button').on('click', onDecline);
  $('table tr .accept.button').on('click', onAccept);
};

function onDecline(event) {
  const $button = $(event.currentTarget);
  const url = $button.attr('data-url');

  if (url && url.length) {
    mountComponent(
      <DeclineModal url={url} onClose={unmountCurrentComponent} />
    );
  } else {
    console.warn(
      'Decline button must have a `data-url` attribute but none specified'
    );
  }
}

function declineConfirmed() {
  unmountCurrentComponent();

  // Storing success notification
  storeSuccess('Demande déclinée avec succès');

  // Reloading page
  window.location.reload(true);
}

function onAccept(event) {
  const $button = $(event.currentTarget);

  const id = $button.closest('tr').attr('data-id');
  const url = $button.attr('data-url');

  if (url && url.length) {
    mountComponent(
      <AcceptAccountRequestModal
        open
        id={id}
        url={url}
        onClose={unmountCurrentComponent}
        onAccepted={acceptConfirmed}
      />
    );
  } else {
    console.warn(
      'Accept button must have a `data-url` attribute but none specified'
    );
  }
}

function acceptConfirmed(response: Response) {
  unmountCurrentComponent();

  // Storing success notification
  storeSuccess('Compte utilisateur créé avec succès');

  redirectToResponse(response);
}

type DeclineProps = {
  url: string,
  onClose: () => void,
};

type DeclineState = {
  isDeclining: boolean,
  error?: Error,
};

class DeclineModal extends Component {
  props: DeclineProps;
  state: DeclineState;

  constructor(props: DeclineProps) {
    super(props);

    this.state = {
      isDeclining: false,
    };
  }

  onDecline = () => {
    const { url } = this.props;

    this.setState({
      isDeclining: true,
    });

    fetch(url, { method: 'POST' })
      .then(declineConfirmed, handleFetchError)
      .catch(error =>
        this.setState({
          isDeclining: false,
          error: displayError(error),
        })
      );
  };

  render() {
    const { onClose } = this.props;
    const { isDeclining, error } = this.state;

    return (
      <Modal closeIcon size="small" open={true} onClose={onClose}>
        <Modal.Header>Déclinaison de la demande</Modal.Header>
        <Modal.Content>
          {error && <Message error content={error} />}
          <p>
            {`
              Êtes-vous sûr(e) de vouloir décliner cette demande ? Elle
              sera définitivement supprimée de cette liste.
            `}
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}>Non</Button>
          <Button
            disabled={!!error}
            onClick={this.onDecline}
            loading={isDeclining}
            negative
            icon="thumbs down"
            labelPosition="right"
            content="Oui"
          />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/requests.js